/**
 *   Created by smuppala in 2023
 */
import { SummaryType } from '@ls/grouping-service';
import { exchange } from '@ls/js-fetch';
import SelectionState from 'state/selections/SelectionState';
import { selectGetGroupingParams, selectSideBySideValue, selectScenarioValue } from 'state/selections/selectors';
import { splitByCalcType } from 'state/util';
import scope from './scope';
import { selectDefinitions } from './selectors';

export const DELETE_DEFINITION = `${scope}/DELETE_DEFINITION`;
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});
export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_GRID_DATA = `${scope}/REQUEST_GRID_DATA`;
export const RECEIVE_GRID_DATA = `${scope}/RECEIVE_GRID_DATA`;
export const REQUEST_VAR_SBS_DATA = `${scope}/REQUEST_VAR_SBS_DATA`;
export const RECEIVE_VAR_SBS_DATA = `${scope}/RECEIVE_VAR_SBS_DATA`;
export const requestGridData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    if (!definitions?.length) {
      return;
    }
    const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(state);
    const [absDefinitions, bmkDefinitions, relDefinitions] = splitByCalcType(definitions);

    const request = async (summary, definitions, benchesToo) => {
      let params = getGroupingParams({
        summary,
        benchesToo,

        var_types: [...new Set(definitions.map(({ scan2CalcType }) => { return [...new Set(definitions.map(({ percentiles }) => `${scan2CalcType}-${percentiles}`))] }))],
        results: ['VAR_GLOBAL', 'VAR'],

      })
      const scenarioValue = selectScenarioValue(SelectionState.COMMITTED)(state);
      const sideBySideValue = selectSideBySideValue(SelectionState.COMMITTED)(state)
      dispatch({ type: REQUEST_GRID_DATA, summary });
      dispatch({
        type: RECEIVE_GRID_DATA,
        summary,
        data: (await exchange({
          params,
          cancelId: `data-${scope}-${summary}`,
          url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
        }))?.data,
      });
      if (!!scenarioValue && !!sideBySideValue) {
        params = { ...params, workspace: scenarioValue }
        dispatch({ type: REQUEST_VAR_SBS_DATA, summary });
        dispatch({
          type: RECEIVE_VAR_SBS_DATA,
          summary,
          data: (
            await exchange({
              url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
              params,
              cancelId: `data-sbs-${scope}-${summary}`,
            })
          )?.data,
        });
      }
    }

    if (absDefinitions.length || bmkDefinitions.length) {
      request(
        SummaryType.ABSOLUTE,
        [...absDefinitions, ...bmkDefinitions],
        bmkDefinitions.length > 0,
      ).then()
    }

    if (relDefinitions.length) {
      request(
        SummaryType.RELATIVE,
        relDefinitions,
        true,
      ).then()
    }
  };
};
